import type { IconName } from "@repo/fika-design-system/icon"
import type { JSX } from "solid-js"
import { Show } from "solid-js"
import { Box } from "../components/box"
import { Icon } from "../components/icon"
import { Text } from "../components/text"
import { blankSlateClass } from "./blank-slate.css"

type Props = {
  children: string
  iconName: IconName
  action?: JSX.Element
}

export function BlankSlate(props: Props) {
  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="16"
      padding={{ block: "64", inline: "16" }}
    >
      <div class={blankSlateClass}>
        <Icon name={props.iconName} size="32" color="sand500" />
        <Text color="sand700" fontSize="m" textAlign="center">
          {props.children}
        </Text>
        <Show when={props.action}>{action => action()}</Show>
      </div>
    </Box>
  )
}
